// Canonical modern genre list used by the admin dropdown + any client-side genre selectors.
// Keep in sync with backend/routes_admin.py `best_genre` criteria.
export const GENRES = [
  "Trap",
  "Melodic Trap",
  "Electronic Trap",
  "Drill",
  "UK Drill",
  "R&B",
  "Pluggnb",
  "Hyperpop",
  "Rage",
  "Phonk",
  "Emo Rap",
  "Emo",
  "Alternative Rock",
  "Metal",
  "Pop",
  "Indie Pop",
  "Melodic",
  "Jersey Club",
  "Afrobeat",
  "Afro",
  "Dancehall",
  "Reggaeton",
  "Latin Trap",
  "World",
  "Lo-Fi",
  "Ambient",
  "Jazz Fusion",
  "Boom Bap",
  "Hip Hop",
  "Grime",
  "Soul",
  "Funk",
  "House",
  "Future Bass",
  "Dubstep",
  "West Coast",
  "Other",
];
